module.exports = __webpack_public_path__ + "img/europas.379f2a7d.png";